import React, { useState } from "react";
import "../sass/PickLocation.scss";
import Input from "./Input";
import Popup from "./Popup";

const SearchLocation = () => {
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  const [searchLoc, setSearchLoc] = useState("");
  const [noLoc, setSoLoc] = useState("");

  const updateInput = (data) => {
    setSearchLoc(data.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      const url = `http://nominatim.openstreetmap.org/?city=${searchLoc}&format=json&limit=1`;

      fetch(url)
        .then((res) => res.json())
        .then(
          (result) => {
            // console.log("result", result);

            if (result.length > 0) {
              setLat(result[0].lat);
              setLong(result[0].lon);
              setSoLoc(0);
            } else {
              // console.log("No location found!");
              setSoLoc(1);
            }
          },
          (error) => {
            console.log("error", error);
          }
        );
    }
  };

  return (
    <Popup>
      <main>
        <div>
          <h2>Search location</h2>
        </div>
        <div>
          <Input
            label="Search"
            type="text"
            value={searchLoc}
            onChange={updateInput}
            onKeyPress={handleKeyPress}
          />

          {lat && long && (
            <span>
              Latitude {lat} <br />
              Longitude {long}
            </span>
          )}

          {noLoc && <span>No location found!</span>}
        </div>
      </main>
    </Popup>
  );
};

export default SearchLocation;
